import React, { memo } from 'react';
import LoadingView from '../../../shared/components/LoadingView/LoadingView';
import GeneralError from '../../../shared/components/GeneralError/GeneralError';
import { useDashboardData } from '../../hooks/useDashboardData';
import TotalCallsContainer from '../../containers/TotalCallsContainer';
import PartitionsStatusContainer from '../../containers/PartitionsStatusContainer';
import StorageUsageContainer from '../../containers/StorageUsageContainer';
import CallSummaryContainer from '../../containers/CallsSummaryContainer';
import ActiveCallsContainer from '../../containers/ActiveCallsContainer';
import MainServicesStatusContainer from '../../containers/MainServicesStatusContainer';
import FirewallPoliciesStatusContainer from '../../containers/FirewallPoliciesStatusContainer';
import FirewallServicesStatusContainer from '../../containers/FirewallServicesStatusContainer';
import WebSecurityStatusContainer from '../../containers/WebSecurityStatusContainer';
import ActivityTimeContainer from '../../containers/ActivityTimeContainer';
import UpdatesStatusContainer from '../../containers/UpdatesStatusContainer';
import WeakPasswordsContainer from '../../containers/WeakPasswordsContainer';
import VPNStatusContainer from '../../containers/VPNStatusContainer';
import styles from './dashboard.module.scss';

export default memo(function Dashboard(props) {
    useDashboardData(props.getDashboardDataRequest, props.unloadDashboard);

    return (
        <>
            {props.isFetching && !props.fetched && <LoadingView />}
            {!props.isFetching && props.error && <GeneralError menu="dashboard" message="general_error" />}
            {
                !props.isFetching &&
                props.fetched &&
                !props.error &&
                <div className={styles.container}>
                    <div className={styles.grid1}>
                        <div className={styles.item1}>
                            <ActivityTimeContainer />
                        </div>
                        <div className={styles.item2}>
                            <UpdatesStatusContainer />
                        </div>
                        <div className={styles.item3}>
                            <ActiveCallsContainer />
                        </div>
                    </div>
                    <div className={styles.grid2}>
                        <div className={styles.item1}>
                            <CallSummaryContainer />
                        </div>
                        <div className={styles.item2}>
                            <div className={styles.subgrid}>
                                <div className={styles.item1}>
                                    <MainServicesStatusContainer />
                                </div>
                                <div className={styles.item2}>
                                    <PartitionsStatusContainer />
                                </div>
                                <div className={styles.item3}>
                                    <VPNStatusContainer />
                                </div>
                                <div className={styles.item4}>
                                    <WeakPasswordsContainer />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.grid3}>
                        <div className={styles.item1}>
                            <StorageUsageContainer />
                        </div>
                        <div className={styles.item2}>
                            <div className={styles.subgrid}>
                                <div className={styles.item1}>
                                    <FirewallPoliciesStatusContainer />
                                </div>
                                <div className={styles.item2}>
                                    <FirewallServicesStatusContainer />
                                </div>
                                <div className={styles.item3}>
                                    <WebSecurityStatusContainer />
                                </div>
                                <div className={styles.item4}>
                                    <TotalCallsContainer
                                        description="dashboard:total_calls_detail"
                                        dictionary="dashboard"
                                        title="dashboard:total_calls"
                                    />
                                </div>
                                <div className={styles.item5}>
                                    {/* <Information /> */}
                                </div>
                                <div className={styles.item6}>
                                    {/* <Information /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}, (prevProps, nextProps) =>
        prevProps.isFetching === nextProps.isFetching &&
        prevProps.getSystemStatisticsRequest === nextProps.getSystemStatisticsRequest &&
        prevProps.fetched && nextProps.fetched &&
        prevProps.unloadDashboard === nextProps.unloadDashboard
);
